// Workspace369's support and setup facts for the compare and alternatives pages.
// Each line repeats a Support & services or CSV import row in data/pricing-features.json,
// with the plans that row marks "yes". Don't add phone support, response times or
// an import tool for a named competitor here.

export const workspaceSupport = {
  featurePath: '/features/support',
  email: 'support@workspace369.com',
  points: [
    'Help by email on every plan.',
    'Onboarding guidance for setup and configuration on every plan.',
    'Searchable product documentation and guides on every plan.',
    'A dedicated support contact for your team on Commander and Enterprise.',
  ],
};
